var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.toggleShare}},[_c('img',{attrs:{"src":require("../../../public/img/newPages/fenxiang.png"),"alt":""}}),_c('span',[_vm._v("分享")]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"social-share",attrs:{"data-sites":"qzone, qq, weibo,wechat, douban"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }